/*
Non autherized user header, only includes logo
*/

import React from "react";
import { Box } from "grommet";
import logo from "../monitoredu-logo.svg";
function NavUnAuth() {
  return (
    <Box
      overflow="auto"
      align="center"
      flex="grow"
      fill
      responsive
      gap="none"
      background="transparent"
      pad={{
        top: "medium",
        horizontal: "medium",
        bottom: "small",
      }}
    >
      <img
        src={logo}
        alt="MonitorEDU Logo"
        style={{
          width: "350px",
          maxWidth: "100%",
          height: "auto",
        }}
      ></img>
    </Box>
  );
}

export default NavUnAuth;
